import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function PublicLayout({ children }) {
    return (
        <div className="min-h-screen flex flex-col bg-[color:var(--bg)]">
            <SiteHeader />
            <main className="flex-1 pt-24 md:pt-36 relative">{children}</main>
            <SiteFooter />
            <WhatsAppButton />
        </div>
    );
}
